import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

import { navbarData } from './navbar-tab';
import { SharedDataService } from '../../services/shared-data.service';
@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, MatSidenavModule, MatTooltipModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  constructor(private sharedDataService: SharedDataService) {}

  collapsed = true;
  navData = navbarData;

  @Output() collapsedChanged = new EventEmitter<boolean>();

  onExpand() {
    this.collapsed = false;
    this.collapsedChanged.emit(this.collapsed);
  }

  onCollapse() {
    this.collapsed = true;
    this.collapsedChanged.emit(this.collapsed);
  }

  onTabSelect(tab: any) {
    this.sharedDataService.updateDashboardState('navBarData', tab);
  }
}
